import { clearPursuitCaches } from '@/components/chat-v2/hooks/usePursuitSummaryCache'
import { isCommercialOnlyPathname } from '@/components/common/Sidebar/lib'

import { IS_FEDRAMP_ENVIRONMENT } from '@/constants/env'

import { usePathname } from '@/hooks/common/usePathname'
import { useSafePush } from '@/hooks/navigation/useSafePush'

export const useHandleOrgChange = () => {
  const pathname = usePathname()

  const { safePush } = useSafePush()

  // god this is a mess
  const handleOrgChange = (orgId: string) => {
    if (!pathname) return
    // Clear pursuit and color caches when switching organizations to prevent stale data
    clearPursuitCaches()
    if (IS_FEDRAMP_ENVIRONMENT && isCommercialOnlyPathname(pathname)) {
      safePush('/')
    } else if (pathname.includes('pipelines')) {
      safePush(`/orgs/${orgId}/pipelines`)
    } else if (pathname.includes('pursuits')) {
      safePush(`/orgs/${orgId}/pursuits`)
    } else if (pathname.includes('schedules')) {
      safePush(`/orgs/${orgId}/schedules`)
    } else if (pathname.includes('library')) {
      safePush(`/orgs/${orgId}/library`)
    } else if (pathname.includes('monitors')) {
      // Monitors pages read orgId straight from the URL segment, so the switch
      // must rewrite the URL (a store-only update gets reverted by
      // useActiveOrgId's route-priority repair). Preserve inbox vs dashboard; a
      // deep /monitors/[monitorId] drops back to the dashboard since that id
      // belongs to the old org.
      safePush(
        pathname.includes('/monitors/inbox')
          ? `/orgs/${orgId}/monitors/inbox`
          : `/orgs/${orgId}/monitors`,
      )
    } else if (pathname.includes('chat')) {
      safePush(`/orgs/${orgId}/chat`)
    } else if (pathname.includes('profile')) {
      safePush(`/orgs/${orgId}/profile`)
    } else if (pathname.includes('/c/')) {
      if (!pathname.includes('recent')) {
        safePush(`/orgs/${orgId}/c/new`)
      } else {
        safePush(`/orgs/${orgId}/c/recent`)
      }
    }
  }

  return {
    handleOrgChange,
  }
}
